import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface BrowseMarketCardProps {
  market: {
    id: number;
    name: string;
    product_image?: string;
    product_image2?: string;
  };
}

export const BrowseMarketCard: React.FC<BrowseMarketCardProps> = ({ market }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/market/${market.id}`);
  };

  // Use product_image2 first, fallback to product_image
  const imageUrl = market.product_image2 || market.product_image || '/images/market-placeholder.jpg';

  return (
    <Card
      sx={{
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 3,
        },
      }}
      onClick={handleCardClick}
    >
      <CardContent>
        <Box display="flex" alignItems="center" gap={2}>
          <CardMedia
            component="img"
            sx={{
              width: 48,
              height: 48,
              objectFit: 'cover',
              backgroundColor: '#f5f5f5',
              borderRadius: 1
            }}
            image={imageUrl}
            alt={market.name}
            onError={(e: any) => {
              e.target.src = '/images/market-placeholder.jpg';
            }}
          />
          <Box>
            <Typography variant="h6">
              {market.name}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};